import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OutsideNotifier from '../../OutsideNotifier';
import { getStep } from './../../route-component';
import {
    resetTransfers,
} from './../../actions/ManageTeamActions';
import {
    triggerHandleFixturePopup,
} from './../../actions/FormationActions';
import {
    resetAllFilters,
} from './../../actions/FilterActions';
import {
    getOutTeamArray
} from "../../helper";
import config from './../../config';
import common from './../../common';
import trackEventsObj from './../../constants/new-pageTrackEvents'

class MoreMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMoreOpen: false
        };
    }

    componentWillUnmount() {
        this.setState({
            isMoreOpen: false,
        });
    }

    toggleMoreIcon = () => {
        this.setState(prevState => ({
            isMoreOpen: !prevState.isMoreOpen,
        }));
    };
    onResetTap = () => {
        // this.props.resetAllFilters();
        common.customTracking("Reset Transfers");
        this.props.resetTransfers();

    };
    onHelpTap = () => {
        common.pageViewTracking(config.HELP_URL, trackEventsObj["help"]);
        return window.open(config.HELP_URL);
    };
    onSettingsTap = () => {
        return this.props.history.push('/settings');
    };
    onUpcomingFixturesTap = () => {
        this.props.triggerHandleFixturePopup(true);
    };
    onViewAllPlayersTap = () => {
    };
    onRulesTap = () => {
        common.pageViewTracking(config.RULES_URL, trackEventsObj["rules"]);
        return window.open(config.RULES_URL);
    };

    render() {
        const location = this.props.location;
        const pageStep = getStep(location.pathname);
        const { teamData, manageTeamRawData, manageTeamMode } = this.props;
        const { IsFixtureUpdated } = this.props.constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        let transferredOut = [];
        if (manageTeamMode === config.modes["transfer"]) {
            transferredOut = getOutTeamArray(teamData, manageTeamRawData);
        }
        const isMoreOpen = this.state.isMoreOpen;
        /* options criteria starts */
        const isViewTeam = manageTeamMode === config.modes["view-manage-team"];
        const isTransfer = manageTeamMode === config.modes["transfer"];
        const isResetOpt = isTransfer;
        const isViewFixturesOpt = isFixtureUpdated && (isViewTeam || isTransfer) && pageStep !== 13;
        const isViewPlayersOpt = isTransfer;
        const isSettings = false;
        const isHelpOpt = true;
        const showRules = false;
        /* options criteria ends */
        const menuClasses = common.makeClasses({
            'si-new-comp': true,
            'si-more-btn': true,
            'si-more-options': true,
            'si-cols': true,
            'si-active': isMoreOpen
        });
        const resetClass = common.makeClasses({
            'si-disabled': transferredOut.length <= 0
        });
        return <div className={ menuClasses } onClick={ () => this.toggleMoreIcon() }>
            <i className="icon-ucl-more" />
            { isMoreOpen ? <OutsideNotifier handler={ this.toggleMoreIcon.bind(this) }>
                <div className="si-more-menu">
                    { isResetOpt ? <span className={ resetClass }
                        onClick={ () => this.onResetTap() }>{ this.props.trans.resetTransfers }</span> : null }
                    { isViewFixturesOpt && common.isMobile() ? <span
                        onClick={ () => this.onUpcomingFixturesTap() }>{ this.props.trans.upcomingFixtures }</span> : null }
                    {/* {isViewPlayersOpt ? <span className="si-disabled"
                                              onClick={() => this.onViewAllPlayersTap()}>{this.props.trans.viewAllPlayers}</span> : null} */}
                    { isSettings ?
                        <span onClick={ () => this.onSettingsTap() }>{ this.props.trans['settings'] }</span> : null }
                    { showRules ? <span onClick={ () => this.onRulesTap() }>{ this.props.trans['menu_rules'] }</span> : null }
                    {/* { isHelpOpt ?
                        <span onClick={ () => this.onHelpTap() }>{ this.props.trans['help_n_feedback'] }</span> : null } */}
                </div>
            </OutsideNotifier> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        teamData: state.formationData.teamData,
        manageTeamRawData: state.formationData.manageTeamRawData,
        manageTeamMode: state.formationData.manageTeamMode,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetTransfers: () => dispatch(resetTransfers()),
        getOutTeamArray: (teamData, oldTeamData) => dispatch(getOutTeamArray(teamData, oldTeamData)),
        resetAllFilters: () => dispatch(resetAllFilters()),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MoreMenu));


// WEBPACK FOOTER //
// ./src/components/onboarding/MoreMenu.js